/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import "@polymer/iron-media-query/iron-media-query.js";
import { mixinBehaviors } from "@polymer/polymer/lib/legacy/class.js";
import { IronResizableBehavior } from "@polymer/iron-resizable-behavior/iron-resizable-behavior.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import template from "./ns-alert.html";

import "@nuskin/ns-style-elements";

const ALERT_BAR = "alert-bar";
const ALERT_BOX = "alert-box";
const BUTTONS = "buttons";
const CENTER_CLOSE_ALERT = "center-close-alert";
const EMPTY = "";
const ERROR = "error";
const ERROR_ICON = "nuskin-color:icon-error-filled";
const HIDE = "hide";
const INFORMATION = "information";
const INFORMATION_ICON = "nuskin-color:icon-info-filled";
const INLINE_BUTTONS = "inline-buttons";
const IRON_RESIZE = "iron-resize";
const SUCCESS = "success";
const SUCCESS_ICON = "nuskin-color:icon-success-filled";
const STACK_BUTTONS = "stack-buttons";
const SINGLE_BUTTON = "single-button";
const WARNING = "warning";
const WARNING_ICON = "nuskin-color:icon-warning-filled";

/**
 *  <p>The ns-alert component is a persistent notification.</p>
 *
 *  <h2>UX/Design Docs</h2>
 *  <a href="https://nuskin.invisionapp.com/d/main#/console/13401975/285637491/inspect​​​​​​​" target="_blank"></a>
 *  <br>
 *  <ns-button href="#elements-app/elements/NsAlert" onclick="window.location='/playground/ns-alert-demo.html';">
 *    NS Alert Playground Demo</ns-button>
 *
 *  <h2>Demo</h2>
 *  <demo-snippet class="demoSnippet">
 *    <template>
 *      <style>
 *      </style>
 *      <h3>Alert Type: Alert Box</h3>
 *      <ns-alert active alert-type="alert-box" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <span slot="submessage">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. </span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *        <ns-button slot="buttons" fluid theme="secondary"> Morbi quis ligula</ns-button>
 *      </ns-alert>
 *      <h3>Alert Type: Alert Bar</h3>
 *      <ns-alert active alert-type="alert-bar" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <span slot="submessage">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. </span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *        <ns-button slot="buttons" fluid theme="secondary"> Morbi quis ligula</ns-button>
 *      </ns-alert>
 *      <h3>The following examples do not specify an alert-type, styling will be based off viewport</h3>
 *      <h3>Default Theme - Gray bar, no header, no icon</h3>
 *      <ns-alert active>
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <span slot="submessage">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. </span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *        <ns-button slot="buttons" fluid theme="secondary"> Morbi quis ligula</ns-button>
 *      </ns-alert>
 *      <h3>Success Theme - Green bar, progress icon.</h3>
 *      <ns-alert active theme="success" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <span slot="submessage">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. </span>
 *      </ns-alert>
 *      <h3>Warning Theme - Yellow bar, warning icon.</h3>
 *      <ns-alert active theme="warning" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *      </ns-alert>
 *      <h3>Error Theme - Red bar, error icon, red header text.</h3>
 *      <ns-alert active theme="error" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *        <ns-button slot="buttons" fluid theme="secondary"> Morbi quis ligula</ns-button>
 *      </ns-alert>
 *      <h3>Information Theme - Blue bar, info icon.</h3>
 *      <ns-alert active theme="information" header="Lorem ipsum dolor sit amet, consectetur adipiscing elit.">
 *        <span slot="message">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>
 *        <span slot="submessage">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque luctus sapien et magna
 *          viverra, sed placerat neque sodales. </span>
 *        <ns-button slot="buttons" fluid theme="primary">Suspendisse vel nisl</ns-button>
 *        <ns-button slot="buttons" fluid theme="secondary"> Morbi quis ligula</ns-button>
 *      </ns-alert>
 *    </template>
 *  </demo-snippet>
 *
 *  <marked-element>
 *    <div slot="markdown-html">
 *      <script type="text/markdown">
 *
 *      ### Styling
 *
 *      `<ns-alert>` currently provides no custom properties and mixins for styling.
 *
 *      ### Slots
 *
 *      ##### `<ns-alert>` provides the following slots for content:
 *
 *      Custom property                 | Description                           | Default
 *      --------------------------------|---------------------------------------|-------------------
 *      `message`                       | default message body                  | none
 *      `submessage`                    | default submessage                    | none
 *      `buttons`                       | buttons for alert (recommended no     |
 *                                      | more than 2 buttons)                  |
 *
 *      </script>
 *    </div>
 *  </marked-element>
 *
 */
export class nsAlert extends mixinBehaviors(
  [IronResizableBehavior],
  PolymerElement
) {
  static get is() {
    return "ns-alert";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * Shows/Hides the alert.
       */
      active: {
        type: Boolean,
        reflectToAttribute: true,
        observer: "init",
        notify: true
      },
      /**
       * READ-ONLY - DO NOT MANUALLY SET
       * Alert class identifies the type of alert for easier styling.
       * This property is automatically set by iron-media-query.
       */
      alertClass: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * Options: alert-box, alert-bar
       * Empty alert-type is responsive and will switch between alert-box and alert-bar
       * based on viewport width.
       */
      alertType: {
        type: String,
        reflectToAttribute: true
      },
      /**
       * Alert header.
       */
      header: {
        type: String
      },
      /**
       * READ-ONLY - DO NOT MANUALLY SET
       * Iron media query used to assign an alert class for more concise css.
       * This property is used by iron-media-query.
       */
      isDesktop: {
        type: Boolean,
        observer: "_setAlertClass"
      },
      /**
       * Options: error, warning, success, information.
       * Empty theme will default to gray bar with no header and no icons.
       */
      theme: {
        type: String,
        observer: "_onThemeChanged"
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener(IRON_RESIZE, this.init.bind(this));
  }

  /**
   * Initializes the component when set to active.
   */
  init() {
    if (this.active) {
      [this.$.message, this.$.submessage, this.$.buttons].forEach((slot) =>
        this._hideSlots(slot)
      );
      this.hideHeader = !this.theme;
      this._setIcon(this.theme);
    }
  }

  /**
   * Shows/Hides the alert
   */
  close() {
    this.active = false;
  }

  /** Private Methods **/

  /**
   * Sets up the alert class based on iron-media-query.
   * Alert type identifies whether the alert is an alert-bar or alert-box regardless of viewport.
   * If alert type is not specified, the alert will switch between alert-box and alert-bar depending on viewport.
   * Alert class on the other hand identifies which CSS to apply.  All alert components will be tagged as either
   * alert-box or alert-bar based on iron-media-query.
   */
  _setAlertClass() {
    this.alertClass =
      this.alertType || (this.isDesktop ? ALERT_BAR : ALERT_BOX);
  }

  /**
   * Sets up corresponding icon for theme.
   * @param {string} theme - Theme value.
   */
  _setIcon(theme) {
    switch (theme) {
      case ERROR:
        this.icon = ERROR_ICON;
        break;
      case WARNING:
        this.icon = WARNING_ICON;
        break;
      case SUCCESS:
        this.icon = SUCCESS_ICON;
        break;
      case INFORMATION:
        this.icon = INFORMATION_ICON;
        break;
      default:
        break;
    }
  }

  /**
   * Hides slots that are empty to prevent css grid from displaying an empty section.
   * @param {*} slot
   */
  _hideSlots(slot) {
    let id = slot.id || slot.target.id;
    let count = this.$[id].assignedNodes().length;
    this[HIDE + id.substring(0, 1).toUpperCase() + id.substring(1)] =
      count <= 0;
    if (id === BUTTONS) {
      this._setLayout(count);
    }
  }

  /**
   * Sets up the layout/position for the buttons and the close (X) icon.
   * @param {*} buttonsCount
   */
  _setLayout(buttonsCount) {
    if (buttonsCount > 1) {
      this.buttonsLayout = INLINE_BUTTONS;
      this.closePosition = CENTER_CLOSE_ALERT;
      if (this.offsetHeight >= 90) {
        this.buttonsLayout = STACK_BUTTONS;
        this.closePosition = EMPTY;
      }
    } else {
      if (buttonsCount === 1) {
        this.buttonsLayout = SINGLE_BUTTON;
      }
      this.closePosition = this.offsetHeight <= 90 ? CENTER_CLOSE_ALERT : EMPTY;
    }
  }

  /**
   * Observer for the theme property.
   * @param {string} theme - New theme value.
   */
  _onThemeChanged(theme) {
    this._setIcon(theme);
  }
}

customElements.define(nsAlert.is, nsAlert);
